import { DayPicker, type Locale as DayPickerLocale, type Matcher } from 'react-day-picker';
import classNames from 'classnames';

import { type CalendarProps } from './calendar.type';
import { CALENDAR_CLASS_NAMES } from './calendar-class-names';

import 'react-day-picker/style.css';
import './calendar-overrides.css';

export const Calendar = ({
  locale,
  minDate,
  maxDate,
  defaultMonth,
  className,
  weekStartsOn,
  'data-testid': dataTestId,
  ...props
}: CalendarProps) => {
  const disabled: Matcher[] = [];
  if (minDate) disabled.push({ before: minDate });
  if (maxDate) disabled.push({ after: maxDate });

  return (
    <div data-testid={dataTestId}>
      <DayPicker
        {...props}
        fixedWeeks
        showOutsideDays
        locale={locale as Partial<DayPickerLocale>}
        defaultMonth={defaultMonth}
        weekStartsOn={weekStartsOn}
        disabled={disabled}
        classNames={CALENDAR_CLASS_NAMES}
        className={classNames('bg-surface-primary', className)}
      />
    </div>
  );
};
